import Address from "./address";
import PaymentTerm from "./paymentTerm";
import Subscription from "./subscription";
import ServiceTrade from "./serviceTrade";
import ServiceArea from "./serviceArea";
import WorkOrder from "./workOrder";

export default class ServiceProvider {
  public idServiceProvider: number = 0;
  public idAddress: number = 0;
  public serviceProviderName: string = "";
  public serviceProviderCode: string = "";
  public phone: string = "";
  public email: string = "";
  public address: Address = new Address();
  public paymentTerm: PaymentTerm = PaymentTerm.None;
  public dispatchInstructions: string = "";
  public isEmailDispatch: boolean = false;
  public isSmsDispatch: boolean = false;
  public isPortalDispatch: boolean = false;
  public workOrderNumberCounter: number = 0;
  public contactPersonName: string = "";
  public contactPersonEmail: string = "";
  public contactPersonPhone: string = "";
  public isMaintenanceCompany: boolean = false;
  public isPublic: boolean = false;
  public insuranceExpirationDate: Date = new Date();
  public subscriptions: Subscription[] = [];
  public serviceTrades: ServiceTrade[] = [];
  public serviceAreas: ServiceArea[] = [];

  /**
   * //these properties still need to be added on UI side
public List<UserGroup> UserGroups { get; set; } = [];
public List<WorkOrder> SentWorkOrders { get; set; } = [];
public List<WorkOrder> ReceivedWorkOrders { get; set; } = [];
     **/

  static tradesToString(serviceProvider: ServiceProvider) {
    if (
      !serviceProvider.serviceTrades ||
      serviceProvider.serviceTrades.length === 0
    ) {
      return "";
    }
    return serviceProvider.serviceTrades
      .map((t) => t.trade.tradeName)
      .join(", ");
  }

  static dispatchMethodToString(serviceProvider: ServiceProvider) {
    var dispatchMethods: string[] = [];

    if (serviceProvider.isEmailDispatch) dispatchMethods.push("By Email");

    if (serviceProvider.isPortalDispatch) dispatchMethods.push("By Portal");

    if (serviceProvider.isSmsDispatch) dispatchMethods.push("By SMS");

    if (dispatchMethods.length === 0) {
      return "";
    }

    return dispatchMethods.join(", ");
  }

  static getName(serviceProvider: ServiceProvider | undefined) {
    if (!serviceProvider) {
      return "";
    }

    return serviceProvider.isPublic
      ? serviceProvider.serviceProviderName + " (Public)"
      : serviceProvider.serviceProviderName;
  }

  static getNameFromWorkOrderParentEntityName(workOrder: WorkOrder) {
    return workOrder.parentEntityIsPublic
      ? workOrder.parentEntityName + " (Public)"
      : workOrder.parentEntityName;
  }
}
